import React from "react";
import "../pages/Home.css";
import { Link } from "react-router-dom";

const Home = () => {
  return (
    <div id="container">
      {/* ===== Marquee ===== */}
      <div className="style20">
        <div className="marquee1">
          <p>मुद्दत समाप्ती : १४/११/२०२६ | HelpLine Contact : ९९७५९७७४६२</p>
        </div>
      </div>
      {/* ===== Header ===== */}
      <header
        className="header"
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          gap: "20px",
          padding: "10px",
        }}
      >
        {/* Logo on left side */}
        <div className="logo" style={{ position: "absolute", left: "20px" }}>
          <img
            src={`${process.env.PUBLIC_URL}/images/sj1.jpg`}
            alt="Grampanchayat Logo"
            style={{ width: "100px", height: "auto" }}
          />
        </div>

        {/* Header Titles */}
        <div style={{ textAlign: "center" }}>
          <h1 className="style1">ग्रामपंचायत गोंडीदिग्रस</h1>
          <h1 className="style1">पंचायत समिती काटोल, जिल्हा परिषद नागपुर</h1>
          <h1 className="style1">महारष्ट्रातील एकमेव ग्रामपंचायत उपक्रम</h1>
        </div>
      </header>

      {/* ===== Marquee ===== */}
      <div className="style20">
        <div className="marquee">
          <p>ग्रामपंचायत गोंडीदिग्रस – तालुका काटोल – जिल्हा नागपूर</p>
        </div>
      </div>

      {/* ===== Main Menu ===== */}
      <nav className="menuicons">
        <ul>
          <li><Link to="/aboutus">About Us</Link></li>
          <li><Link to="/">मुखपृष्ठ</Link></li>
          <li><Link to="/gramsevakpage">ग्रामसेवक</Link></li>
          <li><Link to="/gallery">Gallery</Link></li>
          <li><Link to="/vikas">विकास कामे</Link></li>
          <li><Link to="/sabha">सभेची माहिती</Link></li>
          <li><Link to="/contact">संपर्क करा</Link></li>
           <li><Link to="/pdf">अंदाजपत्रक</Link></li>
        </ul>
      </nav>

      {/* ===== Sub Menu ===== */}
      <div className="menuicons">
        <ul>
          <li><Link to="/janmdakhala">जन्म दाखला</Link></li>
          <li><Link to="/death">मृत्यू दाखला</Link></li>
          <li><Link to="/vivah">विवाह दाखला</Link></li>
          <li><Link to="/gramsevak">ग्रा.वि.अ. कार्यकाल</Link></li>
          <li><Link to="/sarpanch">सरपंच कार्यकाल</Link></li>
          <li><Link to="/upsarpanch">उपसरपंच कार्यकाल</Link></li>
          <li><Link to="/sadasya">सदस्य कार्यकारणी</Link></li>
          <li><Link to="/video"> ग्रामपंचायत विडियो</Link></li>
        </ul>
      </div>

      {/* ===== Main Section ===== */}
      <main>
        <h3 className="style2">कार्यकारी मंडळ ग्रामपंचायत गोंडीदिग्रस</h3>

        <div style={{ overflow: "auto", height: "300px" }}>
          <table>
            <thead>
              <tr>
                <th>अ.क्र.</th>
                <th>नाव</th>
                <th>पद</th>
              </tr>
            </thead>
            <tbody>
              {[
                ["1", "श्रीमती. मंदाताई सुरेंद्र महंत", "सरपंच", ""],
                ["2", "श्री. गौतम नारायण डबरासे", "उपसरपंच", ""],
                ["3", "श्री. दिनेश अण्णाजाब तरारे", "सदस्य", ""],
                ["4", "श्री. प्रदीप पंड्रम पुतुरिया", "सदस्य", ""],
                ["5", "सौ. ममता रूपास महंत", "सदस्य", ""],
                ["6", "सौ. वर्षा संजय मेंडके", "सदस्य", ""],
                ["7", "सौ. उमाबाई पुंडलिक निस्वादे", "सदस्य", ""],
                ["8", "सौ. निकिता अर्जुन तरारे", "सदस्य", ""],
              ].map((row, index) => (
                <tr className="EvenRowColor" key={index}>
                  {row.map((cell, i) => (
                    <td key={i}>{cell}</td>
                  ))}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </main>

      {/* ===== Footer Section ===== */}
      <footer className="footer-section">
        {/* Social Icons */}
        <ul className="social-icons">
          <li>
            <a href="https://www.facebook.com/" target="_blank" rel="noopener noreferrer">
              <img src={`${process.env.PUBLIC_URL}/images/Facebook_logo_(square).png`} alt="Facebook" />
            </a>
          </li>
          <li>
            <a href="https://twitter.com" target="_blank" rel="noopener noreferrer">
              <img src={`${process.env.PUBLIC_URL}/images/Logo_of_Twitter.png`} alt="Twitter" />
            </a>
          </li>
          <li>
            <a href="https://www.instagram.com/kotwalbardi/?utm_source=qr&r=nametag" target="_blank" rel="noopener noreferrer">
              <img src={`${process.env.PUBLIC_URL}/images/instagaram.webp`} alt="Instagram" />
            </a>
          </li>
          <li>
            <a href="https://youtube.com" target="_blank" rel="noopener noreferrer">
              <img src={`${process.env.PUBLIC_URL}/images/youtube.png`} alt="YouTube" />
            </a>
          </li>
        </ul>

        {/* Footer Links */}
        <p className="footer-links">
          <Link to="/copyright">Copyright Policy</Link> |{" "}
          <Link to="/disclaimer">Disclaimer</Link> |{" "}
          <Link to="/privacy">Privacy Policy</Link> |{" "}
          <Link to="/contact">Contact Us</Link>
        </p>

        <p>
          Website Designed, Developed & Maintained by{" "}
          <b>Certnexus India Pvt. Ltd. Nagpur</b>.<br />
          Content provided by Grampanchayat Office, Government of Maharashtra.
        </p>

        <p>© 2025 Certnexus India Pvt. Ltd. Nagpur</p>

        {/* Footer Logos */}
        <div className="footer-logos">
          <a href="https://swachhbharatmission.ddws.gov.in/" target="_blank" rel="noopener noreferrer">
            <img src={`${process.env.PUBLIC_URL}/images/swachh-bharat.png`} alt="Swachh Bharat" />
          </a>
          <a href="https://digitalindia.gov.in" target="_blank" rel="noopener noreferrer">
            <img src={`${process.env.PUBLIC_URL}/images/digital-india-logo.png`} alt="Digital India" />
          </a>
          <a href="https://data.gov.in" target="_blank" rel="noopener noreferrer">
            <img src={`${process.env.PUBLIC_URL}/images/data-gov-logo.png`} alt="Data Portal" />
          </a>
          <a href="https://www.india.gov.in" target="_blank" rel="noopener noreferrer">
            <img src={`${process.env.PUBLIC_URL}/images/portal.jpg`} alt="National Portal" />
          </a>
          <a href="https://mygov.in" target="_blank" rel="noopener noreferrer">
            <img src={`${process.env.PUBLIC_URL}/images/mygov.png`} alt="MyGov" />
          </a>
          <a href="https://www.meity.gov.in" target="_blank" rel="noopener noreferrer">
            <img src={`${process.env.PUBLIC_URL}/images/Meity_logo.png`} alt="MeitY" />
          </a>
          <a href="https://pmindia.gov.in" target="_blank" rel="noopener noreferrer">
            <img src={`${process.env.PUBLIC_URL}/images/pm-india-logo.jpg`} alt="PM India" />
          </a>
        </div>
      </footer>
    </div>
  );
};

export default Home;
